import React from 'react';
import unifiedAuthManager from '../../../services/unifiedAuthManager';

const DashboardHeader = () => {
  const user = unifiedAuthManager.getUnifiedUser();
  // Fallback to "User" if name is not available
  const userName = user?.name
    ? user.name
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ')
    : "";

  return (
    <header className="text-center pt-12 pb-6 anim-slideDown" style={{ animationDuration: "1.5s" }}>
      <p className="text-lg mph-primary font-semibold">Welcome back, {userName}!</p>
      <h1 className="text-3xl font-bold profiler bg-clip-text mt-2">
        Ready to find the perfect matches for <br /> your open positions?
      </h1>
    </header>
  );
};

export default DashboardHeader;